<template>
  <div class="preview" style="height: 100vh;">
    <!--<iframe :src="'data:application/pdf;base64,' + pdfB64" frameborder="0"
    style="overflow:hidden;height:100%;width:100%" height="100%" width="100%"></iframe>-->

    <object :data="'data:application/pdf;base64,' + pdfB64" type="application/pdf" 
    style="overflow:hidden;height:100%;width:100%" height="100%" width="100%"></object>
  </div>
</template>

<script>
  export default {
    components: {},
    name: 'preview',
    props: [],
    data () {
      return {
        pdfB64: '',
      }
    },
    mounted: function () {
      this.pdfB64 = this.$route.params.id
    },
    methods: {
    }
  }
</script>

<style lang="less">
</style>



// WEBPACK FOOTER //
// src/components/HomePage/Preview.vue